import types from './types';
import Cookies from 'react-cookies';
import SoundsUtil from '../../utils/sounds';
import API from '../../utils/api';

export const appPreloaded = () => {
    return {
        type: types.preloaded
    }
}

export const appLoaded = () => {
    return {
        type: types.loaded
    }
}

export const notify = text => {
    return {
        type: types.notify,
        payload: text
    }
}

export const toggleSound = (state) => {
    Cookies.save('sounds', state ? 1 : 0); 
    SoundsUtil.toggle(state);

    return {
        type: types.sounds
    }
}

export const setLanguage = language => {
    Cookies.save('language', language); 
    // SoundsUtil.click();

    return {
        type: types.language,
        payload: language
    }
}

export const loadJackpots = () => async dispatch => {
    const response = await API({
        path: '/games/jackpots'
    });

    if(response.success)
        dispatch({
            type: types.jackpots,
            payload: response.data
        });
}